export default __webpack_public_path__ + "static/media/workouts@2x.f5a0c648.png";